import Client from './client';

export default class WebhookEvents extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  postPaymentAndCallbacksAndPaypal(options = {}) {
    return this.makeRequest(`${this.host}/payment/callbacks/paypal`, {
      ...options,
       method: 'POST',
    });
  }

  postDisputeAndNotificationsAndPaypal(options = {}) {
    return this.makeRequest(`${this.host}/dispute/notifications/paypal`, {
      ...options,
       method: 'POST',
    });
  }

}
